import { AUTH_API, handleApiError } from '../../utils/axios';

export const getModels = async (search, brandId, unpaged) => {
  try {
    const url = unpaged
      ? `/api/v1/brands/${brandId}/models?search=${search.search}`
      : `/api/v1/brands/${brandId}/models?page=${search.page}&size=${search.size}&search=${search.search}`;
    const { data } = await AUTH_API.get(url);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createModel = async (model, brandId) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/brands/${brandId}/models`, model);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateModel = async (model, brandId) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/brands/${brandId}/models/${model.id}`, model);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteModel = async (modelId, brandId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/brands/${brandId}/models/${modelId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
